import { isNil } from "lodash";

class StringUtils {
    static isBlank(str: string) {
        return !str || /^\s*$/.test(str);
    }

    static join(...args: string[]) {
        const buffer = [];
        for (let i = 0; i < args.length; i++) {
            const a = args[i];
            if (a) {
                buffer.push(a);
            }
        }
        return buffer.join("");
    }

    static isContainsNonASCII(str?: string) {
        if (!str) return false;

        for (let i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) > 127) return true;
        }

        return false;
    }

    static isLengthGt(str: string, maxLength: number) {
        if (!str) return false;
        return str.length > maxLength;
    }

    static replaceEmoji(str: string) {
        /** 暂时移除菜鸟不支持的emoji */

        if (typeof str !== "string") return str;

        // ➕ 加号：U+2795
        // ➖ 减号：U+2796
        // ➗ 除号：U+2797
        // ✔ 钩号：U+2714
        // ⭐ 星星：U+2B50
        return str.replace(/[\u2795\u2796\u2797\u2714\u2B50]/gu, " ");
    }

    /**
     * 敏感信息脱敏
     */
    static desensitizedText(str: string) {
        if (isNil(str)) return str;
        if (typeof str !== "string") return str;

        if (str.length > 6) {
            // 当长度大于6时，保证至少输出3个*
            return str.slice(0, 3) + Array(Math.max(str.length - 6, 3) + 1).join("*") + str.slice(str.length - 3);
        } else {
            return str.slice(0, -3) + "***";
        }
    }
}

export default StringUtils;
